export enum ConsultType {
    ClinicLetter = 'CLINIC_LETTER',
    Dictation = 'DICTATION',
    Ed = 'ED',
    Isbar = 'ISBAR',
    MentalHealthInitialAssessment = 'MENTAL_HEALTH_INITIAL_ASSESSMENT',
    OperationNote = 'OPERATION_NOTE',
    Soap = 'SOAP',
    Sotap = 'SOTAP',
    RenalMdMMeetingNotes = 'RENAL_MDM_MEETING_NOTES',
    GeneralPatientMultiDisciplinaryMeeting = 'GENERAL_PATIENT_MULTI_DISCIPLINARY_MEETING',
    DieteticAssessment = 'DIETETIC_ASSESSMENT',
    HONOS = 'HONOS',
}

export function mapToConsultType(value: string): ConsultType | undefined {
    return Object.values(ConsultType).find((state) => value == state)
}

export function consultTypeDisplayValue(type: ConsultType): string {
    switch (type) {
        case ConsultType.ClinicLetter:
            return 'Clinic Letter'
        case ConsultType.Dictation:
            return 'Dictation'
        case ConsultType.Ed:
            return 'ED Note'
        case ConsultType.Isbar:
            return 'ISBAR'
        case ConsultType.MentalHealthInitialAssessment:
            return 'Mental Health Initial Assessment'
        case ConsultType.OperationNote:
            return 'Operation Note'
        case ConsultType.Soap:
            return 'SOAP'
        case ConsultType.Sotap:
            return 'SOTAP'
        case ConsultType.RenalMdMMeetingNotes:
            return 'Renal MDM Meeting Notes'
        case ConsultType.GeneralPatientMultiDisciplinaryMeeting:
            return 'General Patient Multi Disciplinary Meeting'
        case ConsultType.DieteticAssessment:
            return 'Dietetic Assessment'
        case ConsultType.HONOS:
            return 'Honos'
        default:
            return 'Unknown Type'
    }
}

/**
 * A template type string as the consult tabs show it: the known display name,
 * or Title Case for types not in the enum (e.g. PATHOLOGY_REPORT).
 */
export function formatTemplateTypeDisplay(type: string): string {
    const mapped = mapToConsultType(type)
    if (mapped) return consultTypeDisplayValue(mapped)
    return (
        type
            ?.replace(/_/g, ' ')
            ?.replace(
                /\w\S*/g,
                (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
            ) ?? 'Unknown Type'
    )
}
